import React from 'react';

import history from 'providers/history';

import './InstrumentSlide.sass';

type SvgProps = React.SVGProps<SVGElement>;

interface IInstrumentSlideProps {
    svgComponent: React.StatelessComponent<SvgProps>;
    type: string;
    url: string;
}

const InstrumentSlide: React.StatelessComponent<IInstrumentSlideProps> = (props: IInstrumentSlideProps) => {
    const SvgImage = props.svgComponent;
    const { url, type } = props;
    return (
        <div className="Slider-instrument" onClick={() => history.push(url)} >
            <SvgImage className="Slider-instrument-image" />
            <div className="text-center Slider-instrument-type">{type}</div>
        </div>
    );
};

export default InstrumentSlide;



// WEBPACK FOOTER //
// ./src/components/pages/home/InstrumentSlide.tsx